import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'attributes',
            name: 'attribute',
            class: 'Modules\\Site\\Entities\\Attribute'
        }
    }
}